import { useQuery } from '@tanstack/react-query';
import { BASE_API_URL } from '../consts/base-url';
import type { Task } from '../types/task';
import customFetch from '../utils/fetch';
export const useGetTasksInBatch = (batchId?: number, enabled = false) => {
  const {
    data,
    isError,
    error,
    isLoading
  } = useQuery({
    queryKey: ['getTasksInBatch', batchId],
    enabled: enabled && batchId !== null && batchId !== undefined,
    queryFn: async () => {
      const response = await customFetch(`${BASE_API_URL}/batch/${batchId}/task?includeMetadata=true`, {});
      const {
        success,
        error,
        data
      } = (await response.json() as {
        success: boolean;
        error: string | null;
        data: Task[];
      });
      if (!response.ok || !success) {
        throw new Error(error || 'Something went wrong fetching tasks in batch');
      }
      return data;
    },
    retry: false
  });
  return {
    isError,
    error,
    data,
    isLoading
  };
};